import styled from "styled-components"

export const WrapperMain = styled.div`
  position: absolute;
  z-index: 1;
  top: 7%;
  left: 50%;
  transform: translateX(-50%);
`

export const PageTitle = styled.div`
  color: ${props => props.theme.color.white};
  font-family: ${props => props.theme.font.medium};
  font-size: 30px;
  font-weight: 400;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  line-height: normal;
  text-align: center;
  text-transform: uppercase;

  ${props => props.theme.mediaQueries.desktop} {
    font-size: 30px;
  }
  h1 {
    color: ${props => props.theme.color.white};
    font-family: ${props => props.theme.font.medium};
    font-size: 30px;
    font-weight: 400;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    line-height: normal;
    text-align: center;
    text-transform: uppercase;

    ${props => props.theme.mediaQueries.desktop} {
      font-size: 30px;
    }
  }
`

export const BlobContainer = styled.div`
  display: flex;
  color: ${props => props.theme.color.white};
  text-align: center;
  line-height: 30px;
  font-size: 25px;
  font-family: ${props => props.theme.font.light};
  margin-top: ${props => (props.headerHeight ? `${props.headerHeight}px` : 0)};
  @media screen and (min-width: 767px) {
    font-size: 35px;
    line-height: 40px;
  }
  @media screen and (min-width: 1024px) {
    font-size: 45px;
    line-height: 50px;
  }
  canvas {
    z-index: -1;
    width: 200vw;
    position: relative;
  }
`
